import { render, staticRenderFns } from "./TicketsDetails.vue?vue&type=template&id=79fa5cf7&scoped=true"
import script from "./TicketsDetails.vue?vue&type=script&lang=js"
export * from "./TicketsDetails.vue?vue&type=script&lang=js"
import style0 from "./TicketsDetails.vue?vue&type=style&index=0&id=79fa5cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa5cf7",
  null
  
)

export default component.exports